module.exports = __webpack_public_path__ + "img/40_38_045_080.d66f100d.jpg";